<template>
  <div class="binding-account boxShadow">
    <div class="binding-account-title">账号管理</div>

    <div class="hasBorder">
      <p>手机号码 </p>
      <span class="binding-account-label">账号：  <span>{{ phoneNumber }}</span> </span>
      <el-button  size="small" @click="showDialog(1)">更换手机号</el-button>
    </div>
    <div class="hasBorder" v-if="email">
      <p>邮箱号码 </p>
      <span class="binding-account-label">账号：  <span>{{ email }}</span> </span>
      <el-button  size="small" @click="secureBind">解除绑定</el-button> 
      <el-button  size="small" @click="showDialog(2)">更换邮箱</el-button>
    
    </div>

    <div class="bind-weixin">
      <p>微信账号</p>
      <!-- <span class="iconfont weixin-icon">&#xe602;</span> -->
      <span v-if="isBindingWeiXin">微信号：{{ weiXinName }}</span>
      <span class="binding-action" @click="bindingWeiXin">{{isBindingWeiXin ? "解除绑定" : "绑定微信号"}}</span>
  
    </div>

    <el-dialog :title="modifyType==1?'更换手机号':'更换邮箱号码'  " :visible.sync="dialogVisible" width="500px">
      <el-form :model="formData" :rules="formDataRules" ref="ruleForm" class="userAccountChange">
        <el-form-item prop="mobile" v-if="modifyType==1">
          <el-input v-model="formData.mobile" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="mail" v-else>
          <el-input v-model="formData.mail" placeholder="邮箱号码"></el-input>
        </el-form-item>

        <el-form-item prop="captcha" class="captcha"  >
          <el-input
            v-model="formData.captcha"
            :placeholder=" modifyType==1?'短信验证码':'邮箱验证码'">
          </el-input>
          
          <SendCode
            v-if="modifyType==1"
            size="small"
            :mobile="formData.mobile"
            :disabled="!mobileChecked"
            @validate="validateMobile"
            @start="sendCode">
          </SendCode>
          <el-button v-else type="primary"  
           size="small" 
           :disabled="emailDisable"
           @click="getEmailCode">获取邮箱验证码</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="diafooter">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submit" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import SendCode from "../../components/common/sendCode.vue";
const token = window.localStorage.getItem("token");
const qrcodeUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=wx0e6d0828dc561eb1&redirect_uri=https://www.itneituiquan.com/wechatAuth&response_type=code&scope=snsapi_login&state=STATE`;

export default {
  data() {
    const checkMobile = async (rule, value, callback) => {
      const mobileReg = new RegExp(/^1[3456789]\d{9}$/);
      if (!value) {
        this.mobileChecked = false;
        return callback(new Error("不能为空"));
      }
      if (!mobileReg.test(value)) {
        this.mobileChecked = false;
        return callback(new Error("手机号格式不正确"));
      }
      const res = await this.$axios({
        url: `/portal/users/check/mobile/${value}`,
        method: "GET"
      });

      if (res.code === 200) {
        if (res.data) {
          this.mobileChecked = false;
          return callback(new Error("手机号已经注册"));
        } else {
          this.mobileChecked = true;
          callback();
        }
      }
    };

    const checkEmail = async (rule, value, callback) => {
      const mailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if (!value) {
          this.emailDisable = true;
          return callback(new Error('邮箱不能为空'))
        }
        if (mailReg.test(value)) {
            console.log('邮箱格式验证通过',value);
            this.emailDisable = false;
            callback()
        } else {
          console.error('邮箱验证码格式不对！');
          this.emailDisable = true;
          callback(new Error('请输入正确的邮箱格式'))
        }
    };

    return {
      dialogVisible: false,
      modifyType:1,
      formData: {
        mobile: "",
        captcha: "",
        mail:"",
      },
      formDataRules: {
        mobile: [{ validator: checkMobile, trigger: "change" }],
        mail: [{ validator: checkEmail, trigger: "blur" }],
        captcha: [
          { required: true, message: "短信验证码不能为空", trigger: "change" }
        ]
      },
      isBindingWeiXin: false,
      mobileChecked: false,
      emailDisable:false,
    };
  },
  components: {
    SendCode
  },

  computed: {
    phoneNumber() {
      return this.$store.state.user.info.mobile;
    },
    email(){
      return this.$store.state.user.info.email;
    },
    userId() {
      return this.$store.state.user.info.id;
    }
  },
  methods: {
    ...mapActions([
    "checkEmailAction"
    ]),
    // 更换手机号,邮箱账号
    submit() {
      this.$refs["ruleForm"].validate(async valid => {
        if (!valid) {
          return false;
        }
        if(this.modifyType==1){
          const {mobile,captcha} = this.formData;
          const res = await this.$axios({
            url: `/platform/users/binding/${this.userId}`,
            method: "PUT",
            data: { mobile, captcha}
          });
        }else{
          const res = await this.$axios({
            url: `/users/update/email/${this.formData.mail}`,
            method: "PUT",
          });
        }
        if (res.code === 200) {
          this.$message.success("修改成功！");
          this.dialogVisible = false;
        } else {
          this.$message({ type: "error", message: res.message });
        }
      });
    },
    // 发送验证码
    sendCode() {
      console.log('触发了吗?');
      const res = this.$axios({
        url: "/portal/message/sms/send?debug=true",
        method: "POST",
        data: {
          mobile: this.formData.mobile,
          smsTemplateType: "REGIST"
        }
      });
      if (res.code === 200) {
        this.$message({
          type: "success",
          message: "发送短信验证码成功"
        });
      }
    },
    // 验证手机号码
    async validateMobile() {
      this.$refs["ruleForm"].validateField(["mobile"]);
    },
    // 获取微信号状态--> 绑定与否
    async getBindingWeiXinState() {
      const res = await this.$axios({
        url: "/portal/wechat/wechatStatus",
        method: "GET"
      });
      if (res.code === 200) {
        const { isBindWechat, nickeName } = res.data;
        this.isBindingWeiXin = isBindWechat;
        this.weiXinName = nickeName;
      }
    },
    // 绑定微信
    async bindingWeiXin() {
      if (this.isBindingWeiXin) {
        this.$confirm(
          "确认要解除微信绑定吗？确认后将不能使用微信登录内推圈",
          "账号解绑",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
          }
        )
          .then(async () => {
            const res = await this.$axios({
              url: "/portal/wechat/unbundingWechat",
              method: "PUT"
            });
            if (res.code === 200) {
              this.getBindingWeiXinState();
            } else {
              this.$message({
                type: "error",
                message: res.message
              });
            }
          })
          .catch(() => {});
      } else {
        window.open(qrcodeUrl, "_blank");
      }
    },
    //解除绑定的邮箱
    async secureBind() {
      this.$confirm(
        "确认要解除当前绑定的邮箱吗？",
        "邮箱解绑",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        }
      )
      .then(async () => {
          const res = await this.$axios({
            url: "/portal/users/verify/email",
            method: "DEL"
          });
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: '解绑邮箱成功！'
            });
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
      }).catch(() => {});
     
    },
    showDialog(type){
      this.dialogVisible = true;
      this.modifyType = type;
    },
    //获取邮箱验证码
    async getEmailCode() {
      this.btnDisable = true;
      const res =  await this.checkEmailAction(this.formData.mail);
      if(res.code==200){
        setTimeout(()=>{
          this.emailDisable = false;
        },50000)
        return this.$message.success("验证码已发送，请注意查收！");
      }else{
        this.emailDisable = false;
        return this.$message.error(res.message);
      }
    }
  },
  created() {
    this.getBindingWeiXinState();
  }
};
</script>

<style lang="scss">
.binding-account {
  width: 1064px;
  // min-height: 600px;
  background-color: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
  &-title{
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 25px;
    border-bottom: 1px solid #EBEBEB;
    padding-bottom: 10px;
  }
  &-label {
    margin-right: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0,0,0,0.65);
    span{
      height: 32px;
      background: rgba(40, 124, 243, .1);
      border-radius: 4px;
      padding:2px 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0,0,0,0.65);
      margin-left: 30px;

    }

  }
  
  .hasBorder{
    border-bottom: 1px solid #EBEBEB;
    padding-bottom: 10px;
    p{
      padding: 20px 0 10px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0,0,0,0.85);

    }
    .el-button{
      border: none;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #287CF3;
      &:hover{
        background: none;
      }
    }
  }
  .captcha .el-form-item__content {
    display: flex;
  }
  .captcha{
    position: relative;
    .el-button--primary{
      position: absolute;
      right: 0px;
      top: 5px;
      background: none;
      border: none;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1677FF;
    }
    .getCode{
      position: absolute;
      top: 2px;
      right: 15px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1677FF;
      cursor: pointer;
    }
  }

  .bind-weixin {
    // display: flex;
    // align-items: center;
    // margin-top: 20px;
    p{
      padding: 20px 0 10px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0,0,0,0.85);
    }
  }
  .weixin-icon {
    font-size: 22px;
    margin-right: 20px;
    
  }
  .binding-action {

    cursor: pointer;
    font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #287CF3;
  }
  .diafooter{
    .el-button--primary{
      background: #287CF3;
      box-shadow: 0px 0px 1px 0px rgba(0,27,102,0.08), 0px 1px 4px -1px rgba(0,42,140,0.08), 0px 2px 8px -2px rgba(0,27,102,0.08);
      border-radius: 4px;
      border-color: #287CF3;
    }
  }
  
}
</style>
